import {
    insightAreaListPageRequest,
    insightAreaItemRequest
} from "../../../actions/insight-area-actions"
import buildListContainer from "../../common/build-list-container"
import InsightAreaListItem from "./InsightAreaListItem"
import InsightAreaListItemShadow from "./InsightAreaListItemShadow"

export default buildListContainer(
    InsightAreaListItem,
    InsightAreaListItemShadow,
    insightAreaListPageRequest,
    insightAreaItemRequest,
    "insightAreas",
    "topics"
)
